import { categories } from "@/mocks/categories";
import SectionHeading from "./SectionHeading";

export default function CategoryGrid() {
  return (
    <section id="topic" className="scroll-mt-24 w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          eyebrow="主题分类 · 五大板块"
          title="挑你关心的那一块看"
          desc="时间线很长的时候，用板块来收窄范围会更省事。每个板块都有独立的更新节奏，点进去就是该板块按时间排列的全部快讯。"
          tone="accent"
        />

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat, index) => (
            <a
              key={cat.id}
              href="#live"
              className={`group rounded-lg overflow-hidden border border-background-200 bg-background-50 transition-colors hover:border-accent-400 cursor-pointer ${
                index === 0 ? "lg:col-span-2" : ""
              }`}
            >
              <div className={`flex ${index === 0 ? "flex-col md:flex-row" : "flex-col"}`}>
                <div
                  className={`relative shrink-0 ${
                    index === 0 ? "w-full md:w-[240px] h-[180px] md:h-auto md:min-h-[210px]" : "w-full h-[160px]"
                  }`}
                >
                  <img
                    src={cat.image}
                    alt={`${cat.name}板块配图`}
                    title={`${cat.name} - 瓜田速递主题分类`}
                    className="w-full h-full object-cover object-top"
                  />
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-black/45 text-background-50 text-xs backdrop-blur-sm">
                    <i className={cat.icon} aria-hidden="true"></i>
                    {cat.name}
                  </span>
                </div>

                <div className="flex-1 p-4 md:p-5 flex flex-col">
                  <div className="flex items-center justify-between gap-3">
                    <h3 className="font-heading text-lg md:text-xl text-foreground-950 group-hover:text-accent-800 transition-colors">
                      {cat.name}
                    </h3>
                    <span className="shrink-0 text-xs text-foreground-500">
                      <span className="font-heading text-base text-foreground-900 tabular-nums">{cat.count}</span> 条
                    </span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{cat.desc}</p>
                  <div className="mt-auto pt-4 flex flex-wrap gap-2">
                    {cat.keywords.map((kw) => (
                      <span
                        key={kw}
                        className="px-2 py-0.5 rounded-full bg-accent-50 text-accent-800 text-xs"
                      >
                        {kw}
                      </span>
                    ))}
                    <span className="ml-auto inline-flex items-center gap-1 text-xs text-accent-700">
                      查看板块
                      <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}